import { createSlice } from '@reduxjs/toolkit';
import { format } from 'date-fns';
import { isoToDateString, subDateUnits } from 'utils/date';

const regexUTCDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/;
const regexRelativeDate = /^-(\d+)([smhdwMy])$/;
const dateFormat = "dd MMMM yyyy";


const setDefaultParams = (defaults) => {
    const params = {};
    for(const key in defaults) {
        if(defaults[key].match(regexUTCDate)) {
            params[key] = isoToDateString(defaults[key]);
        }
        else{
            const match = defaults[key].match(regexRelativeDate);
            if(match) {
                params[key] = format(subDateUnits(new Date(), match[1], match[2]), dateFormat);
            }
            else defaults[key].length >0 && (params[key] = defaults[key]);  }  
    }
    return params;
}

const initialState = {
    selected: {},
    params: {},
    exportType: 'excel'
};

const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
        setSelected: (state, {payload}) => {
            const {defaults, ...selected} = payload;
            state.selected = selected; 
            state.params = setDefaultParams(defaults);
        },
        resetSelection: (state) => { state.selected =  ''; },
        setParams: (state, {payload}) => { state.params[payload.name] = payload.value },
        resetParams: (state) => { state.params = {} },
        setExportType: (state, { payload }) => {state.exportType = payload}
    }
});

export const {
    setSelected,
    resetSelection,
    setParams,
    resetParams,
    setExportType
} = reportSlice.actions;

export default reportSlice.reducer;